"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
/* eslint-disable react/jsx-fragments */
/* eslint-disable no-plusplus */
/* eslint-disable no-loop-func */
const malty_atoms_icon_1 = require("@carlsberggroup/malty.atoms.icon");
const malty_atoms_text_1 = require("@carlsberggroup/malty.atoms.text");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const Stepper_styled_1 = require("./Stepper.styled");
const Stepper = ({ steps, currentStep, isMultiStep, dataQaId }) => {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const [elHtml, setElHtml] = (0, react_1.useState)([react_1.default.createElement(react_1.default.Fragment, null)]);
    (0, react_1.useEffect)(() => {
        if (Array.isArray(steps)) {
            steps.map((step, index) => setElHtml((prevState) => [
                ...prevState,
                // eslint-disable-next-line react/jsx-fragments
                react_1.default.createElement(react_1.default.Fragment, { key: `step_${step.key}` },
                    react_1.default.createElement(Stepper_styled_1.StyledStep, { "data-testid": `${dataQaId}-${index}`, theme: theme },
                        react_1.default.createElement(Stepper_styled_1.StyledStepperCircle, { key: `progressStep_circle_${step.key}`, active: currentStep >= index + 1, currentStep: currentStep === index + 1, theme: theme },
                            react_1.default.createElement(react_1.default.Fragment, null,
                                currentStep > index + 1 && (react_1.default.createElement(malty_atoms_icon_1.Icon, { name: malty_atoms_icon_1.IconName.ItemCheckFilled, size: malty_atoms_icon_1.IconSize.Small, color: malty_atoms_icon_1.IconColor.DigitalBlack })),
                                currentStep <= index + 1 && !isMultiStep && (react_1.default.createElement(Stepper_styled_1.StyledStepperNumber, { theme: theme, active: currentStep >= index + 1 }, index + 1)))),
                        react_1.default.createElement(Stepper_styled_1.StyledText, { theme: theme },
                            react_1.default.createElement(malty_atoms_text_1.Text, { dataQaId: `${dataQaId}-${index}-text`, textStyle: malty_atoms_text_1.TextStyle.MicroBold, color: currentStep >= index + 1 ? malty_atoms_text_1.TextColor.DigitalBlack : malty_atoms_text_1.TextColor.Support60 }, step.label))),
                    index + 1 < steps.length && (react_1.default.createElement(Stepper_styled_1.StyledStepperLine, { key: `progressStep_line_${step.key}`, theme: theme, active: currentStep > index + 1 })))
            ]));
        }
        else {
            for (let step = 1; step <= steps; step++) {
                setElHtml((prevState) => [
                    ...prevState,
                    react_1.default.createElement(react_1.default.Fragment, { key: `step_${step}` },
                        react_1.default.createElement(Stepper_styled_1.StyledStep, { "data-testid": `${dataQaId}-${step}`, theme: theme },
                            react_1.default.createElement(Stepper_styled_1.StyledStepperCircle, { key: `progressStep_circle_${step}`, active: currentStep >= step, currentStep: currentStep === step, theme: theme },
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    currentStep > step && (react_1.default.createElement(malty_atoms_icon_1.Icon, { name: malty_atoms_icon_1.IconName.ItemCheckFilled, size: malty_atoms_icon_1.IconSize.Small, color: malty_atoms_icon_1.IconColor.DigitalBlack })),
                                    currentStep <= step && !isMultiStep && (react_1.default.createElement(Stepper_styled_1.StyledStepperNumber, { theme: theme, active: currentStep >= step }, step))))),
                        step < steps && (react_1.default.createElement(Stepper_styled_1.StyledStepperLine, { key: `progressStep_line_${step}`, theme: theme, active: currentStep > step })))
                ]);
            }
        }
        return () => {
            setElHtml([react_1.default.createElement(react_1.default.Fragment, null)]);
        };
    }, [steps, currentStep]);
    return (react_1.default.createElement(Stepper_styled_1.StyledStepperContainer, { "data-testid": dataQaId, theme: theme }, elHtml.map((el) => (react_1.default.createElement(react_1.default.Fragment, { key: el.key }, el)))));
};
exports.Stepper = Stepper;
//# sourceMappingURL=Stepper.js.map